/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurling = createReactComponent("outline", "curling", "IconCurling", [["path", { "d": "M4 9m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v2a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M4 14h16", "key": "svg-1" }], ["path", { "d": "M8 5h6a2 2 0 0 1 2 2v2", "key": "svg-2" }]]);

export { IconCurling as default };
//# sourceMappingURL=IconCurling.mjs.map
